import React from 'react';
import { useHLSPlayer } from '../../hooks/useHLSPlayer';

interface HLSVideoPlayerProps {
  apiUrl: string; // Original API endpoint from response.answer
  contentType: 'video' | 'audio';
  thumbnailUrl?: string;
  className?: string;
  style?: React.CSSProperties;
  autoplay?: boolean;
  controls?: boolean;
  muted?: boolean;
  onLoadStart?: () => void;
  onLoadEnd?: () => void;
  onError?: (error: any) => void;
  children?: React.ReactNode;
}

const HLSVideoPlayer: React.FC<HLSVideoPlayerProps> = ({
  apiUrl,
  contentType,
  thumbnailUrl,
  className,
  style,
  autoplay = false,
  controls = true,
  muted = false,
  onLoadStart,
  onLoadEnd,
  onError,
  children
}) => {
  const { videoRef, isLoading, usingFallback } = useHLSPlayer({
    apiUrl,
    contentType,
    autoplay,
    controls,
    muted,
    onLoadStart,
    onLoadEnd,
    onError
  });

  return (
    <div style={{ position: 'relative', ...style }} className={className}>
      <video
        ref={videoRef}
        style={{ 
          width: '100%', 
          height: '100%',
          objectFit: 'cover',
          backgroundColor: '#000'
        }}
        controls={controls}
        autoPlay={autoplay}
        muted={muted}
        poster={thumbnailUrl}
        playsInline
      />
      
      {/* <div style={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          background: 'rgba(0,0,0,0.7)',
          color: 'white',
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          zIndex: 10
        }}>
          {usingFallback ? '📼 Fallback' : '🎬 HLS'}
        </div> */}

      {children}
    </div>
  );
};

export default HLSVideoPlayer;